import { createAction, props } from "@ngrx/store";
import { MySeasonPassIndex } from "../interfaces/State/MySeasonPasses/index";
import { SeasonPassPurchase } from "../interfaces/State/MySeasonPasses/seasonPassPurchase";

export const setCurrentMySeasonPasses = createAction('setCurrentMySeasonPasses', props<{seasonPasses: {[key:string] : MySeasonPassIndex}}>())
export const clearCurrentMySeasonPasses = createAction('clearCurrentMySeasonPasses')
export const setExpiredMySeasonPasses = createAction('setExpiredMySeasonPasses', props<{seasonPasses: {[key:string] : MySeasonPassIndex}}>())
export const updateCurrentMySeasonPass = createAction('updateCurrentMySeasonPass', props<{seasonPassPurchase:SeasonPassPurchase, seasonPassSlug: string}>())
